import { Tooltip } from '@odo/shared-ui';
import type { PracticeRiskStatus } from '../../services/practiceRisk';
import {
    PRACTICE_RISK_ICONS,
    PRACTICE_RISK_PILL_CLASSES,
    PRACTICE_RISK_STATUS_LABELS,
    practiceRiskTooltipContent
} from './practiceRisk';

interface RiskStatusPillProps {
    riskStatus: PracticeRiskStatus;
    riskNote: string | null;
    className?: string;
}

/**
 * Bordered status pill for a practice's own risk flag (normal/warning/at_risk)
 * - the practice detail header's identity row (see PracticeDetailHeader) is
 * the only caller today. Renders nothing for 'normal' - there's no badge for
 * the default state, matching every other identity chip on that header.
 */
export function RiskStatusPill({ riskStatus, riskNote, className = '' }: RiskStatusPillProps) {
    if (riskStatus === 'normal') return null;

    const RiskIcon = PRACTICE_RISK_ICONS[riskStatus];

    return (
        <Tooltip content={practiceRiskTooltipContent({ riskStatus, riskNote })} side="bottom">
            <span
                className={`inline-flex items-center gap-1 text-[11px] font-semibold rounded-full px-2 py-0.5 whitespace-nowrap ${PRACTICE_RISK_PILL_CLASSES[riskStatus]} ${className}`}
            >
                <RiskIcon className="h-3.5 w-3.5" aria-hidden="true" />
                {PRACTICE_RISK_STATUS_LABELS[riskStatus]}
            </span>
        </Tooltip>
    );
}
